import React from "react";

function AuditTrailFinance({ histories = [] }) {
  return (
    <div className="row">
      <div className="col-md-12 col-xs-12">
        <div className="table-responsive">
          <table className="table text-center">
            <thead>
              <tr>
                <th className="text-center">Timestamp</th>
                <th className="text-center">Username</th>
                <th className="text-center">Category</th>
                <th className="text-center">Description</th>
                <th className="text-center">Investor Name</th>
                <th className="text-center">Amount</th>
              </tr>
            </thead>
            <tbody>
              {histories.map((history, key) => (
                <tr key={key}>
                  <td>{history.timestamp}</td>
                  <td>
                    {history.first_name} {history.last_name}
                  </td>
                  <td>{history.category}</td>
                  <td>{history.description}</td>
                  <td>{history.investor_name}</td>
                  <td>{history.amount}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AuditTrailFinance;



// WEBPACK FOOTER //
// ./src/components/audit-trail/finance.js